import styled from "styled-components";

export const TeleopButtons = styled.div`
    flex-grow: unset;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 1.25rem;
    align-items: center;
`;
